<template src="./u-switch.html" />
<script src="./u-switch.ts" lang="ts"></script>
<style src="./u-switch.scss" scoped lang="scss"></style>
